/*
 * @Author: JamesWong
 * @Description: 自助收银中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-03 16:06:53
 */
export default {
  authorizedDevice: '授權設備',
  remainDevices: '剩餘可用授權設備數',
  order: '序號',
  authorizationTime: '授權時間',
  machineNumber: '機器編碼',
  machineCode: '設備機器碼',
  operate: '操作',
  cancelAuthorization: '取消授權',
  cancelAuthorizeDevice: '取消授權設備',
  cancelAuthorizationTips: '確定取消授權設備？',
  cancel: '取消',
  confirm: '確定',
  rollingPhotos: '輪播圖片',
  uploadPhotosTips: '圖片比例16：9，大小不超過5M',
  upload: '上傳',
  previewPhotos: '預覽圖片',
  delete: '刪除',
  deleted: '刪除成功',
  createQRcode: '開卡二維碼',
  uploadQRcodeTips: '圖片比例1：1，大小不超過1M',
  uploadingTips: '文件正在上傳中...請稍等',
  uploadProgress: '上傳進度',
  Unnamed: '未命名',
  photoUploaded: '上傳視頻成功！',
  phoneSizeTips: '檔案大小不能超過1M！',
  phoneSizeTips5: '檔案大小不能超過5M！',
  longNameTips: '檔案名不能過長！',
  noPhotoTips: '你還沒有上傳圖片，趕快上傳吧',
  deletedError: '刪除失敗！',
  cancelAuthorized: '取消授權成功！'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-hant/self.js